<template>

  <div class="w-100">
    <div class="row text-right" v-for="menu in storeMenus" :key="menu.id" v-if="menu.position === 'store_nav'">
      <NavMenuItem class="text-right " v-if="menu.children.length" v-for="item in menu.children" :item="item"
                   :key="item.id"/>

    </div>
  </div>

</template>
<script>
import {mapGetters} from "vuex";
import NavMenuItem from "./NavMenuItem";
import axios from "axios";

export default {
  name: "MainMenu",
  components: {NavMenuItem},
  data() {
    return {
      shoppingCartCount: 0
    };
  },
  methods: {
    countItemsOnUnAuthenticatedShoppingCart() {
      const localProducts = localStorage.products;
      this.shoppingCartCount = localProducts != undefined ? Object.keys(JSON.parse(localStorage.products)).length : 0;
    }
  },
  computed: {
    ...mapGetters({
      storeMenus: "Menu/getStoreMenus",
      isAuth: "User/isAuthenticated",
      orderCount: 'ShoppingCart/getSidebarBasketData',
    }),
    getBaseUrl() {
      return axios.defaults.baseURL.replace('api/', '')
    },
  },
  async mounted() {
    if (this.isAuth) {
      await this.$store.dispatch("ShoppingCart/userOrderUnpaid");
    }
    window.addEventListener('DOMContentLoaded', this.countItemsOnUnAuthenticatedShoppingCart);
    window.addEventListener('click', this.countItemsOnUnAuthenticatedShoppingCart);
  },
};
</script>

<style scoped>

</style>